import { render, staticRenderFns } from "./ArticleCollection.vue?vue&type=template&id=ae6611d8&scoped=true&"
import script from "./ArticleCollection.vue?vue&type=script&lang=js&"
export * from "./ArticleCollection.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCollection.vue?vue&type=style&index=0&id=ae6611d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6611d8",
  null
  
)

export default component.exports